(function () {
    const accordion = document.querySelectorAll("[data-accordion]")

    if (accordion) {
        accordion.forEach(item => {
            item.addEventListener('click', (e) => {
                const self = e.currentTarget
                const panel = self.nextElementSibling

                self.classList.toggle('active')

                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null
                } else {
                    panel.style.maxHeight = panel.scrollHeight + 'px'
                }
            })
        })
    }
}());
